<div class="holidays container m-0 p-0">
  <div class="row">
    <div class="col dialog-title">New office</div>
  </div>
  <div class="row">
    <div class="col dialog-content">
      <form [formGroup]="form">
        <div class="office">
          <div class="modal__item">
            <label
              class="label-input"
              appMarkAsterisk
              [formGroup]="form"
              [controlName]="'officeName'"
              [touched]="form.get('officeName')!.touched"
              >Office name
            </label>
            <div class="modal-validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="officeName"
              />
              <app-error-field
                [displayError]="
                  isFieldInvalid('officeName', form) &&
                  form.get('officeName')!.hasError('required')
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
              <app-error-field
                [displayError]="form.get('officeName')!.hasError('maxlength')"
                [errorMessage]="'Max field length = 40'"
              ></app-error-field>
            </div>
          </div>
          <div class="modal__item">
            <label
              class="label-input"
              appMarkAsterisk
              [formGroup]="form"
              [controlName]="'address'"
              [touched]="form.get('address')!.touched"
              >Address
            </label>
            <div class="modal-validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="address"
              />
              <app-error-field
                [displayError]="
                  isFieldInvalid('address', form) &&
                  form.get('address')!.hasError('required')
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
              <app-error-field
                [displayError]="form.get('address')!.hasError('maxlength')"
                [errorMessage]="'Max field length = 40'"
              ></app-error-field>
            </div>
          </div>
          <div class="modal__item">
            <label
              class="label-input mr-16"
              appMarkAsterisk
              [formGroup]="form"
              [controlName]="'countryName'"
              [touched]="form.get('countryName')!.touched"
              >Country
            </label>
            <div class="modal-validation">
              <app-autocomplete-field
                [dynamicFilter]="selectedCountry.data"
                [countryFilter]="true"
                formControlName="countryName"
              >
              </app-autocomplete-field>
              <app-error-field
                [displayError]="
                  isFieldInvalid('countryName', form) &&
                  form.get('countryName')!.hasError('required')
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row align-items-center justify-content-end dialog-buttons">
    <div class="col-auto p-0 mb-3">
      <button class="button button__save add-margin" (click)="saveTheData()">
        Save
      </button>
      <button class="button button__cancel" (click)="closeTheModal()">
        Cancel
      </button>
    </div>
  </div>
</div>
